var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"summary"},[_vm._v("\n    Open Invoice Count: "+_vm._s(_vm.overdue_invoices_count)+" / "+_vm._s(_vm.open_invoices_count)+" (Overdue / Total Open)\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }